var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'omit';

import Input from '../Input';

import styles from './DatePickerInput.scss';

var DatePickerInput = function (_Component) {
  _inherits(DatePickerInput, _Component);

  function DatePickerInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePickerInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePickerInput.__proto__ || Object.getPrototypeOf(DatePickerInput)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePickerInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var desiredProps = omit(['style', 'customInput'], this.props);
      var _props = this.props,
          style = _props.style,
          onClick = _props.onClick,
          _onEnterPressed = _props.onEnterPressed;

      var customInput = this.props.customInput || React.createElement(Input, null);

      return React.createElement(
        'div',
        { style: style, onClick: onClick },
        React.cloneElement(customInput, _extends({
          ref: function ref(Input) {
            return _this2.input = Input;
          },
          onEnterPressed: function onEnterPressed() {
            return _onEnterPressed() && _this2.blur();
          },
          onEscapePressed: function onEscapePressed() {
            return _this2.blur();
          }
        }, desiredProps, customInput.props))
      );
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.input.blur();
    }
  }]);

  return DatePickerInput;
}(Component);

DatePickerInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  dateFormat: PropTypes.func,
  style: PropTypes.object,
  onEnterPressed: PropTypes.func,
  customInput: PropTypes.node
};
DatePickerInput.defaultProps = {
  prefix: React.createElement('div', { className: styles.icon }),
  onEnterPressed: function onEnterPressed() {}
};
export default DatePickerInput;
//# sourceMappingURL=DatePickerInput.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/DatePicker/DatePickerInput.js